import styled from 'styled-components';

const CardButton = styled.button.attrs({
  className: 'bundle-card__button',
})`
  font-size: 14px;
  font-weight: 700;
  background: none;
  text-align: center;
  box-sizing: border-box;
  border: none;

  &:disabled {
    color: #637381;
  }
`;

export default CardButton;
